module.exports = __webpack_public_path__ + "img/manajemen_kepegawaian_pengajuan_ditolak.36987263.svg";